'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('../colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselFallback = function CarouselFallback() {
  return _react2.default.createElement(
    'div',
    {
      className: 'item active',
      style: {
        backgroundColor: _colors.silver,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      } },
    _react2.default.createElement(_Icon2.default, { name: 'picture-3', color: _colors.alloy, size: '3x' }),
    _react2.default.createElement(
      'p',
      { className: 'text-center', style: { color: _colors.slate, marginBottom: 0 } },
      'No image available'
    )
  );
};

exports.default = CarouselFallback;